export default __webpack_public_path__ + "static/media/ic_next.901a928e.svg";